<template>
	<div class="login-layout">
		<VApp>
			<VMain>
				<NuxtPage :transition="{ name: 'fade', mode: 'out-in'}"/>
			</VMain>
			<CoreNotification />
		</VApp>
	</div>
</template>